<template>
	<section class="form-group FormDropdown" :data-entry="id || name">
		<label v-if="label" class="title" :for="id || name" :class="{ required }">{{ label }}</label>
		<div class="input-area">
			<i v-if="icon" :class="{ [`icon-${icon}`]: true }"></i>
			<select class="input" :id="`${formId}_${id || name}`" v-bind="$attrs" :value="value" @change="$emit('change', $event.target.value)">
				<template v-for="option in options">
					<optgroup v-if="option.group" :label="option.group" :key="option.group">
						<option v-for="opt in option.options" :value="opt.value" :key="opt.value">
							{{ opt.label }}
						</option>
					</optgroup>
					<option v-else :value="option.value" :key="option.value">
						{{ option.label }}
					</option>
				</template>
			</select>
		</div>
	</section>
</template>

<script>
	import mixin from './mixin';
	export default {
		mixins: [mixin],
		props: ['options']
	};
</script>

<style scoped lang="scss">
	.FormDropdown {
		.input-area {
			select {
				outline: none;
				border: none;
				padding: 1rem 1.5rem;
				background-color: var(--backgroundColor);
				border-radius: 0.5rem;
				font-size: inherit;

				-webkit-appearance: none;
				-moz-appearance: none;
				text-indent: 1px;
				text-overflow: '';

				&::-ms-expand {
					display: none;
				}
			}

			&::after {
				content: '';
				display: block;
				width: 2rem;
				height: 2rem;
				background-image: url("data:image/svg+xml,%3Csvg width='18' height='10' viewBox='0 0 18 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17 1L9 9L1 1' stroke='%23666' stroke-width='2' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
				background-repeat: no-repeat;
				background-position: center;
				position: absolute;
				top: 50%;
				right: 1.6rem;
				transform: translateY(-50%);
				pointer-events: none;
			}
		}
	}
</style>
